module.exports = __webpack_public_path__ + "img/th.fd3b2e9c.svg";